module.exports = __webpack_public_path__ + "img/wodebangzhu.aded7fd1.png";